<template>
  <div>
    <div class="pesquisa">
      <h2>procurar e marcar</h2>
      <label>
        <gmap-autocomplete
          @place_changed="setPlace">
        </gmap-autocomplete>
        <button @click="addMarker">Adc</button>
      </label>
      <br/>

    </div>
    <br>
    <gmap-map
      :center="center"
      :zoom="15"
      style="width:100%;  height: 78%; position: absolute"
    >

      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      >
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
  export default {
    name: 'GoogleMap',
    data () {
      return {
        center: { lat: -20.318889, lng: -40.337778 },
        markers: [],
        places: [],
        currentPlace: null
      }
    },

    mounted () {
      this.geolocate()
    },

    methods: {
      // receives a place object via the autocomplete component
      setPlace (place) {
        this.currentPlace = place
      },
      addMarker () {
        if (this.currentPlace) {
          const marker = {
            lat: this.currentPlace.geometry.location.lat(),
            lng: this.currentPlace.geometry.location.lng()
          }
          this.markers.push({ position: marker })
          this.places.push(this.currentPlace)
          this.center = marker
          this.currentPlace = null
        }
      },
      geolocate: function () {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      }
    }
  }
</script>
<style scoped>
.pesquisa{

  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// GoogleMap.vue?2ea5a3a0